import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useTitle} from "../../../contexts/title";
import './help.scss';
import contactUs from './img/ContactUs.png';
import faq_icon from './img/FAQ.png';

export default function HelpPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Help')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block help-page'}>
				<div className='dx-card wide-card'>
					<div className={'help-block'}>
						<div className={'title'}>How can we help you?</div>
						<div className='help-element'>
							<Link to={'/cfi/help/contact-us'} >
								<img src={contactUs} className={'help-image'} ></img>
								Contact Us
							</Link>
						</div>
						<div className='help-element'>
							<Link to={'/cfi/help/faqs'} >
								<img src={faq_icon} className={'help-image'}></img>
								FAQs
							</Link>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
} 
